import * as React from "react";
const SvgFiRrMapMarkerSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-map-marker-slash_svg__a)">
      <path
        fill="#062147"
        d="M16.635 20.321a1 1 0 0 1-.056 1.413l-.793.733A5.4 5.4 0 0 1 12 24a5.42 5.42 0 0 1-3.807-1.552L4.25 18.805C1.314 15.871.273 11.626 1.504 7.701a1 1 0 1 1 1.908.598 8.98 8.98 0 0 0 2.224 9.064l3.935 3.635c1.336 1.306 3.542 1.286 4.837.02l.813-.752a1 1 0 0 1 1.413.056zm7.072 3.386a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293l2.725 2.725A10.92 10.92 0 0 1 12 0c2.938 0 5.7 1.145 7.778 3.222A10.92 10.92 0 0 1 23 11a10.92 10.92 0 0 1-3.018 7.568l3.725 3.725a1 1 0 0 1 0 1.414M5.847 4.433 18.57 17.155A8.92 8.92 0 0 0 21 11.001a8.94 8.94 0 0 0-2.636-6.364A8.94 8.94 0 0 0 12 2.001c-2.306 0-4.48.861-6.153 2.432"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-map-marker-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMapMarkerSlash;
